@if (device() && locationId()) {
  <mat-card class="card my-4">
    @if (deviceHasRealtimeAttributes()) {
      <div
        class="items-center justify-between"
        [class.flex]="!isMobile"
      >
        <mat-form-field
          class="select-classic"
          [ngClass]="{ 'w-full mb-3': isMobile, 'max-w-[232px]': !isMobile }"
          appearance="outline"
        >
          <mat-select
            (valueChange)="chartChange($event)"
            [disabled]="isLoading()"
            [value]="selectedChart()"
            panelClass="single-select-overlay"
          >
            <mat-select-trigger>
              {{ selectedFriendlyName() || selectedChart() }}
            </mat-select-trigger>

            @for (attribute of attributes(); track attribute.friendlyName || attribute.title) {
              <mat-option [value]="attribute.value">
                <div class="flex py-2">
                  <div class="attributes">
                    <div>
                      {{ attribute.friendlyName || attribute.title }}
                    </div>
                    <div>
                      {{ attribute.friendlyName ? attribute.title : ' ' }}
                    </div>
                  </div>
                  @if (!friendlyNameEditDisabled()) {
                    <div
                      class="edit-friendly-name"
                      (click)="openEditDataPointPopup(attribute)"
                      [showForClientAdmin]="true"
                      avsRestrictedEl
                    >
                      <mat-icon class="m-0">edit</mat-icon>
                    </div>
                  }
                </div>
              </mat-option>
            }
          </mat-select>
          <mat-icon
            class="arrow-down"
            fontIcon="keyboard_arrow_down"
            matSuffix
          />
        </mat-form-field>

        <div class="flex items-center gap-2">
          <avs-date-picker
            class="block"
            (changed)="dateRange.set($event)"
            (changedId)="selectedDateRangeId.set($event)"
            [config]="{
              customRange: !isMobile,
            }"
            [disabled]="isLoading()"
            [minDate]="minDate"
            [ngClass]="{
              'w-full': isMobile,
              'w-72 my-4': !isMobile
            }"
            [value]="selectedDateRangeId()"
          />

          @if (!isMobile) {
            <button
              class="border rounded-xl w-[40px] h-[40px] text-center text-ui-gray-100"
              (click)="refreshCharts()"
              [disabled]="isLoading()"
            >
              @if (isLoading()) {
                <mat-spinner
                  class="ml-2"
                  color="primary"
                  diameter="20"
                  matSuffix
                />
              } @else {
                <mat-icon
                  class="text-4xl ml-[-3px] mt-[3px]"
                  fontIcon="refreshIcon"
                />
              }
            </button>
          }
        </div>
      </div>
      <div class="test-chart-container">
        @if (isEnergyConsumptionChart) {
          <avs-li-energy-consumption-widget [chartData]="deviceCharts()[selectedChart()]" />
        }
        @if (chartData(); as chartData) {
          <highcharts-chart
            class="h-[400px] w-full block"
            [class.is-mobile]="isMobile"
            [oneToOne]="true"
            [options]="chartData"
          />
        } @else {
          <ngx-skeleton-loader [theme]="{ height: '400px' }" />
        }
      </div>
    } @else {
      <avs-no-data-placeholder
        class="h-[400px]"
        noDataText="No data points"
      >
        @if (!isMobile) {
          <img
            alt="placeholer_img"
            src="assets/icons/datapoints-placeholder.svg"
          />
        }
      </avs-no-data-placeholder>
    }
  </mat-card>
} @else {
  <div class="test-skeleton-loading">
    <ngx-skeleton-loader [theme]="{ height: '300px' }" />
  </div>
}
